export enum AgentPreviewStatus {
  UNDER_ACTIVATION = 'UNDER_ACTIVATION',
  REVOKED = 'REVOKED',
  UNDER_REVOCATION = 'UNDER_REVOCATION',
}
